import { AchConfiguration } from './types';

const defaultProps: AchConfiguration = {
    hasHolderName: true
};

export default defaultProps;
